import { render, staticRenderFns } from "./DeviceWorkOrderRecord.vue?vue&type=template&id=747dfee8&scoped=true"
import script from "./DeviceWorkOrderRecord.vue?vue&type=script&lang=js"
export * from "./DeviceWorkOrderRecord.vue?vue&type=script&lang=js"
import style0 from "./DeviceWorkOrderRecord.vue?vue&type=style&index=0&id=747dfee8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747dfee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747dfee8')) {
      api.createRecord('747dfee8', component.options)
    } else {
      api.reload('747dfee8', component.options)
    }
    module.hot.accept("./DeviceWorkOrderRecord.vue?vue&type=template&id=747dfee8&scoped=true", function () {
      api.rerender('747dfee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAccounts/DeviceWorkOrderRecord/DeviceWorkOrderRecord.vue"
export default component.exports